<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="700"
    >
 

      <template v-slot:activator="{ on, attrs }">



          <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      color="primary"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

 


       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          icon
          data-cy="add-opcion-input"
       @click="opcionEditColor" 
       >
       
       <v-icon left>mdi-format-color-fill</v-icon></v-btn>
       
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
            Selección del color para el Link 
        </v-card-title>

        <v-card-text>
          <!-- {{opcion}} -->
          <v-container>
    <v-row>

        <v-col cols="12">
          <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
  
   
 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>
  
      <v-col cols="2">

      </v-col>


      Seleccionar el color de fondo

      
      <v-col
        class="d-flex"
      >

        <v-color-picker v-model="color"></v-color-picker>
      </v-col>
      <v-col
        cols="10"
        md="4"
      >
  </v-col>

  <v-col cols="6">

    <v-text-field
           v-model="opcion.color"
           label="Codigo color"
       
         ></v-text-field>

 <v-btn
        :disabled="!valid"
        color="blue"
        class="mr-4"
        @click="copiarColor"
      >
        Copiar Color
      </v-btn>


  </v-col>

      <v-divider></v-divider>

        <v-card-actions>

            <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarOpcion"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>



          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="seleccionarColor"
          >
            Seleccionar Color
          </v-btn>
        </v-card-actions>

      
    </v-form> 

        </v-col>
    </v-row>
  </v-container>

        </v-card-text>

        
      </v-card>
    </v-dialog>
  </div>
</template>


<script>


import opcionService from "@/services/opcionService.js";


  export default {
    name:"OpcionColor",

     props: {
    opcionData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },

  },

    data: () => ({

      mensaje:{
          snackbar: false,
          text: '',
          timeout: 2000,
      },

       opcion:{

descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
observacion:'',
id:'',
color:'#1F7087',
icon:'mdi-instagram',
principal:{}

          
        }
    ,
       valid: false,
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],



      types: ['hex', 'hexa', 'rgba', 'hsla', 'hsva'],
      type: 'hex',
      hex: '#FF00FF',
      hexa: '#FF00FFFF',
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },
      dialog:false,
    }),
    methods:{

      copiarColor(){

  // Utilizando la API del portapapeles
      navigator.clipboard.writeText(this.opcion.color).then(() => {
      
      this.mensaje.text="Color copiado correctamente";

      this.mensaje.snackbar="true";
    
    
    }).catch(err => {
        console.error('Error al copiar el color: ', err);
      });


      },
     opcionEditColor(){
      console.log(this.opcionData);
      this.opcion=this.opcionData;
    },
    
    colorEdit(){
      console.log(this.color);
    },
    seleccionarColor(){


         this.$emit('colorEdit',this.color);
         
        this.dialog=false;

    },
    registrarOpcion(){

            if (this.$refs.form.validate()) {

              let res;
   // this.redirect='/opcion';

  console.log('El ide esta vacio '+this.opcion.id);

  
     //   this.opcion.color='#1F7087';
    if(this.opcion.id===""){

        console.log('El ide esta vacio '+this.opcion.id);

            opcionService.save(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            
            this.$emit('opcionEditColor',this.opcion);
            this.dialog=false;
            
    }else{

      console.log("Ingrese a actualizar");
    opcionService.update(this.opcion).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response.data);
       
        }).catch((errors) =>{

           console.log('error');
            console.log(errors);
        })
        console.log(res);
            }
            this.$emit('opcionEditColor',this.opcion);
            this.dialog=false;
        }
        
        }

        
        ,







    validate(){
      if (this.$refs.form.validate()) {
       // this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.opcion={
				nombre:'',
        apellido:'',
				linkPhoto:'',
				descripcion:'',
				observacion:'',
				id:'',
	}
    },

    },

    computed: {
      color: {
        get () {
          return this[this.type]
        },
        set (v) {
          this[this.type] = v
        },
      },
      showColor () {
        if (typeof this.color === 'string') return this.color

        return JSON.stringify(Object.keys(this.color).reduce((color, key) => {
          color[key] = Number(this.color[key].toFixed(2))
          return color
        }, {}), null, 2)
      },
    },
  watch: {
    color(newValue) {
      

      this.opcion.color=newValue;
    }
  }
  }
</script>